module.exports = __webpack_public_path__ + "img/selk.0ffcbd13.jpg";